// Recent projects ("Your recent shorts") persisted in the browser's localStorage.
// Device/browser-scoped only — this is NOT server-side history. Used to let a user
// return to a previously created short from the landing page without needing the
// requestId URL. See SHORTSCREATOR_TIKTOK_RESUBMISSION_PLAN.md (Change Set C).

const KEY = 'shortscreator_recent_projects';
const CAP = 12; // keep only the most recent N

export function getRecentProjects() {
    try {
        const raw = localStorage.getItem(KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
    } catch (e) {
        return [];
    }
}

export function saveRecentProjects(list) {
    try {
        const capped = (list || []).slice(0, CAP);
        localStorage.setItem(KEY, JSON.stringify(capped));
        return capped;
    } catch (e) {
        return list || [];
    }
}

// Add (or move-to-front) a project. Shape: { id, title, thumbnail, duration, status, date }
export function addRecentProject(project) {
    if (!project || !project.id) return getRecentProjects();
    const list = getRecentProjects().filter((p) => p.id !== project.id);
    list.unshift(project);
    return saveRecentProjects(list);
}

export function removeRecentProject(id) {
    const list = getRecentProjects().filter((p) => p.id !== id);
    return saveRecentProjects(list);
}
